import React from 'react'
import { Link } from 'gatsby'
import classnames from 'classnames'

import { container, content, bg, header, bread } from './Hero.module.scss'

const Hero = ({ title, featuredImage, className, ...props }) => {
  return (
    <div className={classnames(container, className)} {...props}>
      <div className={content}>
        <h1 className={header}>{title}</h1>
        <ol
          className={bread}
          itemScope
          itemType="https://schema.org/BreadcrumbList"
        >
          <li
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem"
          >
            <Link to={'/'} itemProp="item">
              <span itemProp="name">Home</span>
            </Link>
            <meta itemProp="position" content="1" />
          </li>
          <li
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem"
          >
            <span itemProp="name">{title}</span>
            <meta itemProp="position" content="2" />
          </li>
        </ol>
      </div>
      {featuredImage && (
        <img
          src={featuredImage.sourceUrl}
          srcSet={featuredImage.srcSet}
          width={featuredImage.mediaDetails.width}
          height={featuredImage.mediaDetails.height}
          alt={featuredImage.altText}
          className={bg}
        />
      )}
    </div>
  )
}

export default Hero
